import axios from "axios";
import { useEffect, useState } from "react";

function LanguageModal({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState(1);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState(null); // ✅ track selected

  useEffect(() => {
    if (isOpen) {
      fetchCurrencies();

      // ✅ Get selected country from localStorage when modal opens
      const savedCurrency = JSON.parse(localStorage.getItem("selectedCurrency"));
      if (savedCurrency) {
        setSelectedCurrency(savedCurrency);
      }
    }
  }, [isOpen]);

  const fetchCurrencies = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/getCurrency`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data && res.data.status) {
        setCurrencies(res.data.data || []);
      } else {
        setError(res.data.msg || "Failed to fetch currencies");
      }
    } catch (err) {
      console.error("Currency fetch error:", err);
      setError("Something went wrong while fetching currencies");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectCurrency = (currency) => {
    // ✅ Save selected currency to state + localStorage
    setSelectedCurrency(currency);
    localStorage.setItem("selectedCurrency", JSON.stringify(currency));
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        id="language_region"
        className={`modal fade all_modalss ${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        role="dialog"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content detailspgess">
            <div className="modal-header">
              <button type="button" className="close" onClick={onClose}>
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="shedow_booox">
                <div className="content-wrapper">
                  <div
                    id="tab-1"
                    className={`tab-content ${activeTab === 1 ? "active" : ""}`}
                  >
                    <div className="al_titlss_ara">
                      <h3>Choose your currency</h3>

                      <div className="lang_liststs">
                        {loading ? (
                          <p>Loading currencies...</p>
                        ) : error ? (
                          <p className="text-danger">{error}</p>
                        ) : (
                          <ul>
                            {currencies.map((c) => {
                              const isSelected =
                                selectedCurrency?.id === c.id;

                              return (
                                <li key={c.id} onClick={() => handleSelectCurrency(c)} className={` ${isSelected ? "selected" : ""}`}>
                                  <p>
                                    {c.country_name}
                                  </p>
                                  <span>
                                    {c.currency} – {c.symbol}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* (Optional) Tab-2 for future */}
                  <div
                    id="tab-2"
                    className={`tab-content mr_top_20 ${
                      activeTab === 2 ? "active" : ""
                    }`}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background overlay */}
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
}

export default LanguageModal;
